import { Currency } from '@ps/web-core-enums';
import type { TranslationTag } from '@ps/web-core-intl';
import type { MessageDescriptor } from 'react-intl';

import {
  TXTCLI_2_7_Single_Draw,
  TXTCLI_2_7_Triple_Draw,
  TXTCLI_5_Card_Draw_1,
  TXTCLI_5_Card_Omaha,
  TXTCLI_8_Game,
  TXTCLI_Badugi,
  TXTCLI_Courchevel,
  TXTCLI_Fixed,
  TXTCLI_Fusion,
  TXTCLI_HORSE,
  TXTCLI_HOSE,
  TXTCLI_HoldXem,
  TXTCLI_HoldXem_Mixed,
  TXTCLI_Hyper,
  TXTCLI_Knockout,
  TXTCLI_Mixed,
  TXTCLI_Mixed_Omaha,
  TXTCLI_Mixed_Omaha_Hi_Lo,
  TXTCLI_NLHE_PLO,
  TXTCLI_No_Limit,
  TXTCLI_Omaha,
  TXTCLI_PLHE_PLO,
  TXTCLI_PNL,
  TXTCLI_Play_Money,
  TXTCLI_Pot_Limit,
  TXTCLI_Progressive_Knockout,
  TXTCLI_Progressive_Total_Knockout,
  TXTCLI_Razz,
  TXTCLI_Regular,
  TXTCLI_Regular___1_rebuyX_1_addon,
  TXTCLI_Regular___2_rebuysX_1_addon,
  TXTCLI_Regular___2_rebuysX_no_addon,
  TXTCLI_Regular___no_rebuys,
  TXTCLI_Regular___unlimited_rebuysX_1__ELL_1,
  TXTCLI_Shootout,
  TXTCLI_Showtime_HoldXem,
  TXTCLI_Showtime_Omaha,
  TXTCLI_Slow,
  TXTCLI_Split_HoldXem,
  TXTCLI_Split_Omaha,
  TXTCLI_Stud,
  TXTCLI_Swap_HoldXem,
  TXTCLI_Triple_Draw_A_5,
  TXTCLI_Triple_Stud,
  TXTCLI_Turbo,
  TXTHHY_6X_HoldXem,
  TXTHHY_6_Card_Omaha,
  TXTHHY_All_In_Poker,
  TXTHHY_Deep_Water_HoldXem,
  TXTHHY_Deep_Water_Omaha
} from './games.messages.json';

const EMPTY_MESSAGE_DESCRIPTOR: TranslationTag & Partial<MessageDescriptor> = {
  id: '123',
  defaultMessage: '',
  description: ''
};

export enum HandTypeTranslation {
  HT_NONE = 'HT_NONE',
  HT_HOLDEM = 'HT_HOLDEM',
  HT_OMAHA = 'HT_OMAHA',
  HT_STUD = 'HT_STUD',
  HT_RAZZ = 'HT_RAZZ',
  HT_DRAW = 'HT_DRAW',
  HT_3_DRAW_27 = 'HT_3_DRAW_27',
  HT_3_DRAW_A5 = 'HT_3_DRAW_A5',
  HT_SINGLE_DRAW_27 = 'HT_SINGLE_DRAW_27',
  MULTI_GAME_HOSE = 'MULTI_GAME_HOSE',
  MULTI_GAME_HORSE = 'MULTI_GAME_HORSE',
  MULTI_GAME_HOLDEM_MIXED = 'MULTI_GAME_HOLDEM_MIXED',
  MULTI_GAME_OMAHA_HILO_MIXED = 'MULTI_GAME_OMAHA_HILO_MIXED',
  MULTI_GAME_EIGHT_GAME = 'MULTI_GAME_EIGHT_GAME',
  MULTI_GAME_HOLDEM_OMAHA_PL = 'MULTI_GAME_HOLDEM_OMAHA_PL',
  MULTI_GAME_HOLDEM_NL_OMAHA = 'MULTI_GAME_HOLDEM_NL_OMAHA',
  MULTI_GAME_TRIPLE_STUD = 'MULTI_GAME_TRIPLE_STUD',
  HT_BADUGI = 'HT_BADUGI',
  HT_5_OMAHA = 'HT_5_OMAHA',
  HT_COURCHEVEL = 'HT_COURCHEVEL',
  HT_6_OMAHA = 'HT_6_OMAHA',
  MULTI_GAME_OMAHA_MIXED = 'MULTI_GAME_OMAHA_MIXED',
  HT_SPLIT_HOLDEM = 'HT_SPLIT_HOLDEM',
  HT_SPLIT_OMAHA = 'HT_SPLIT_OMAHA',
  HT_SHOWTIME_HOLDEM = 'HT_SHOWTIME_HOLDEM',
  HT_SHOWTIME_OMAHA = 'HT_SHOWTIME_OMAHA',
  HT_FUSION = 'HT_FUSION',
  HT_SIX_PLUS_HOLDEM = 'HT_SIX_PLUS_HOLDEM',
  HT_SWAP_HOLDEM = 'HT_SWAP_HOLDEM',
  HT_DEEP_WATER_HOLDEM = 'HT_DEEP_WATER_HOLDEM',
  HT_DEEP_WATER_OMAHA = 'HT_DEEP_WATER_OMAHA',
  HT_TEMPEST_HOLDEM = 'HT_TEMPEST_HOLDEM'
}

export const HAND_TYPE_TRANSLATIONS_MAP: {
  [K in HandTypeTranslation]: TranslationTag & Partial<MessageDescriptor>;
} = {
  HT_NONE: EMPTY_MESSAGE_DESCRIPTOR,
  [HandTypeTranslation.HT_HOLDEM]: TXTCLI_HoldXem,
  [HandTypeTranslation.HT_OMAHA]: TXTCLI_Omaha,
  [HandTypeTranslation.HT_STUD]: TXTCLI_Stud,
  [HandTypeTranslation.HT_RAZZ]: TXTCLI_Razz,
  [HandTypeTranslation.HT_DRAW]: TXTCLI_5_Card_Draw_1,
  [HandTypeTranslation.HT_3_DRAW_27]: TXTCLI_2_7_Triple_Draw,
  [HandTypeTranslation.HT_3_DRAW_A5]: TXTCLI_Triple_Draw_A_5,
  [HandTypeTranslation.HT_SINGLE_DRAW_27]: TXTCLI_2_7_Single_Draw,
  [HandTypeTranslation.MULTI_GAME_HOSE]: TXTCLI_HOSE,
  [HandTypeTranslation.MULTI_GAME_HORSE]: TXTCLI_HORSE,
  [HandTypeTranslation.MULTI_GAME_HOLDEM_MIXED]: TXTCLI_HoldXem_Mixed,
  [HandTypeTranslation.MULTI_GAME_OMAHA_HILO_MIXED]: TXTCLI_Mixed_Omaha_Hi_Lo,
  [HandTypeTranslation.MULTI_GAME_EIGHT_GAME]: TXTCLI_8_Game,
  [HandTypeTranslation.MULTI_GAME_HOLDEM_OMAHA_PL]: TXTCLI_PLHE_PLO,
  [HandTypeTranslation.MULTI_GAME_HOLDEM_NL_OMAHA]: TXTCLI_NLHE_PLO,
  [HandTypeTranslation.MULTI_GAME_TRIPLE_STUD]: TXTCLI_Triple_Stud,
  [HandTypeTranslation.HT_BADUGI]: TXTCLI_Badugi,
  [HandTypeTranslation.HT_5_OMAHA]: TXTCLI_5_Card_Omaha,
  [HandTypeTranslation.HT_COURCHEVEL]: TXTCLI_Courchevel,
  [HandTypeTranslation.HT_6_OMAHA]: TXTHHY_6_Card_Omaha,
  [HandTypeTranslation.MULTI_GAME_OMAHA_MIXED]: TXTCLI_Mixed_Omaha,
  [HandTypeTranslation.HT_SPLIT_HOLDEM]: TXTCLI_Split_HoldXem,
  [HandTypeTranslation.HT_SPLIT_OMAHA]: TXTCLI_Split_Omaha,
  [HandTypeTranslation.HT_SHOWTIME_HOLDEM]: TXTCLI_Showtime_HoldXem,
  [HandTypeTranslation.HT_SHOWTIME_OMAHA]: TXTCLI_Showtime_Omaha,
  [HandTypeTranslation.HT_FUSION]: TXTCLI_Fusion,
  [HandTypeTranslation.HT_SIX_PLUS_HOLDEM]: TXTHHY_6X_HoldXem,
  [HandTypeTranslation.HT_SWAP_HOLDEM]: TXTCLI_Swap_HoldXem,
  [HandTypeTranslation.HT_DEEP_WATER_HOLDEM]: TXTHHY_Deep_Water_HoldXem,
  [HandTypeTranslation.HT_DEEP_WATER_OMAHA]: TXTHHY_Deep_Water_Omaha,
  [HandTypeTranslation.HT_TEMPEST_HOLDEM]: TXTHHY_All_In_Poker
};

export const PotTypeTranslations: Record<string, TranslationTag> = {
  STRUCT_NOT_DEFINED: EMPTY_MESSAGE_DESCRIPTOR,
  STRUCT_LIMIT: TXTCLI_Fixed,
  STRUCT_POT_LIMIT: TXTCLI_Pot_Limit,
  STRUCT_NO_LIMIT: TXTCLI_No_Limit,
  STRUCT_POT_NO_LIMIT: TXTCLI_PNL,
  STRUCT_MULTI_GAME_MIXED: TXTCLI_Mixed
};

export const PlayMoney: { text: string; value: Currency.PlayMoney } = {
  text: TXTCLI_Play_Money.defaultMessage,
  value: Currency.PlayMoney
};

export const Speed = {
  HG_TOURN_SPEED_REGULAR: 10,
  HG_TOURN_SPEED_HYPER: 3,
  HG_TOURN_SPEED_TURBO: 5,
  HG_TOURN_SPEED_SLOW: 15
};

export const SpeedTranslations: Record<string, TranslationTag> = {
  HG_TOURN_SPEED_REGULAR: TXTCLI_Regular,
  HG_TOURN_SPEED_HYPER: TXTCLI_Hyper,
  HG_TOURN_SPEED_TURBO: TXTCLI_Turbo,
  HG_TOURN_SPEED_SLOW: TXTCLI_Slow
};

export const FormatTranslations: Record<string, TranslationTag> = {
  REGULAR: TXTCLI_Regular___no_rebuys,
  REBUY_1R1A: TXTCLI_Regular___1_rebuyX_1_addon,
  REBUY_2R1A: TXTCLI_Regular___2_rebuysX_1_addon,
  REBUY_2RNOA: TXTCLI_Regular___2_rebuysX_no_addon,
  REBUY: TXTCLI_Regular___unlimited_rebuysX_1__ELL_1,
  KNOCKOUT: TXTCLI_Knockout,
  PROGRESSIVE_KO: TXTCLI_Progressive_Knockout,
  SHOOTOUT: TXTCLI_Shootout,
  TOTAL_KO: TXTCLI_Progressive_Total_Knockout
};
